<script lang="ts" setup>
    import { useTheme } from 'vuetify';
    import { IMenuItem } from '@/types';

    const { items = [] } = defineProps<{
        items: IMenuItem[];
    }>();

    const theme = useTheme();
    const route = useRoute();
    const { t } = useI18n();

    // const clear = (): void => {
    //     menuStore.selection = [];
    // };

    onMounted((): void => {
        console.log('Component app-menuNav mounted.');
    });
</script>
<template>
    <!--    <div>-->
    <v-menu offset-y open-on-hover v-for="item in items as IMenuItem[]" :key="item.title" open-delay="100">
        <template v-slot:activator="{ props }">
            <router-link
                v-if="item.link"
                class="link-plain"
                :to="{
                    name: item.link,
                    params: item.params ? item.params : {},
                }"
            >
                <v-btn
                    tag="a"
                    density="default"
                    color="#cecece"
                    class="font-weight-medium font14 mx-1 px-3"
                    v-bind="props"
                    style="letter-spacing: 0"
                    :class="[item.link === route.name ? 'v-item--active v-list-item--active' : '']"
                >
                    <v-icon v-if="item.icon" :color="item.iconColor" size="20px">
                        {{ item.icon }}
                    </v-icon>
                    <span :class="theme.name.value === 'dark' ? 'text-white' : 'text-black'" class="text-none">
                        {{ t('menu.' + item.title) }}
                    </span>
                </v-btn>
            </router-link>

            <v-btn tag="a" v-else density="default" color="#cecece" class="font-weight-medium font14 mx-1 px-3" v-bind="props" style="letter-spacing: 0">
                <span :class="theme.name.value === 'dark' ? 'text-white' : 'text-black'" class="text-none" v-if="t('menu.' + item.title)">
                    {{ t('menu.' + item.title) }}
                </span>
                <span class="text-none font-weight-bold" v-else>
                    {{ item.title }}
                </span>
                <v-icon size="16" :color="theme.name.value === 'dark' ? '' : 'black'" :icon="mdiChevronDown" />
            </v-btn>
        </template>

        <v-list v-if="item.subItems" class="submenu pa-1 rounded" nav>
            <!--                <v-list-group v-model="selection[item.title]">-->
            <div v-for="subItem in item.subItems" :key="subItem.title" class="pb-1" style="height: 36px">
                <v-list-subheader v-if="!subItem.link" :class="theme.name.value === 'dark' ? 'text-white' : 'text-black'" class="pl-2 font-weight-black text-uppercase pt-1" style="height: 32px">
                    {{ t('menu.' + subItem.title) }}
                </v-list-subheader>
                <router-link
                    v-else
                    :to="{
                        name: subItem.link,
                        params: subItem.params ? subItem.params : {},
                    }"
                    class="text-black link-plain"
                >
                    <v-list-item nav base-color="grey" style="min-height: 32px" class="py-2" :class="[subItem.link === route.name ? 'v-item--active v-list-item--active' : '']">
                        <!--                                <v-list-item-content class="">-->
                        <v-list-item-title :class="theme.name.value === 'dark' ? 'text-white' : 'text-black'" class="font-weight-medium">
                            <v-icon v-if="subItem.icon" :color="subItem.iconColor" size="16px" class="mb-1">
                                {{ subItem.icon }}
                            </v-icon>
                            {{ t('menu.' + subItem.title) }}
                        </v-list-item-title>
                        <!--                                </v-list-item-content>-->
                    </v-list-item>
                </router-link>
                <v-divider v-if="subItem.divider" class="mt-1"></v-divider>
            </div>
            <!--                </v-list-group>-->
        </v-list>
    </v-menu>
    <!--    </div>-->
</template>
<style scoped>
    .v-list-item--nav .v-list-item-title {
        font-size: 13px;
    }

    .v-list-item--nav.v-list-item--active {
        background-color: #f5f5f5;
    }

    .v-theme--dark .v-list-item--nav.v-list-item--active {
        background-color: #494b51;
    }

    .v-menu > .v-overlay__content > .v-theme--dark.v-card,
    .v-menu > .v-overlay__content > .v-theme--dark.v-sheet,
    .v-menu > .v-overlay__content > .v-theme--dark.v-list {
        background: #2b2d31;
    }

    .v-theme--light .v-list-item--nav.v-list-item:hover {
        background-color: #fcfcfc;
    }

    .v-theme--dark .v-list-item--nav.v-list-item:hover {
        background-color: #35373b;
    }
</style>
